import React from 'react'

const PaymentDetails = ({details}) => {

    console.log('Details',details)
    const {payer,purchase_units} = details
    console.log('Payer',payer)
    console.log('units',purchase_units)
  return (
    <div className='payment-info container border border-success rounded text-center p-2'>
        <h3 className="text-success">Your Booking is Successful</h3>
        <p>Name : <span>{payer.name.given_name}</span></p>
        <p>Email : <span>{payer.email_address}</span></p>
        <p>PaymentID :<span>{payer.payer_id}</span></p>
        <p>Amount : <span>AUD{purchase_units[0].amount.value}</span></p>
        <p></p>
        <p></p>
    </div>
  )
}

export default PaymentDetails